import React from "react";
import SkillItem from "./SkillItem";

const skillData = [
  {
    id: 1,
    title: "Html5, Css3, Scss",
    percentage: "95%",
  },
  {
    id: 2,
    title: "Bootstrap4, Bootstrap5, Reacjs Bootstrap",
    percentage: "98%",
  },
  {
    id: 3,
    title: "PHP",
    percentage: "100%",
  },
  {
    id: 4,
    title: "Codeigntier",
    percentage: "100%",
  },
  {
    id: 5,
    title: "Laravel",
    percentage: "90%",
  },
  {
    id: 5,
    title: "Wordpress",
    percentage: "98%",
  },
  {
    id: 6,
    title: "ReactJS",
    percentage: "80%",
  },
  {
    id: 7,
    title: "MongoDB",
    percentage: "95%",
  },  
  {
    id: 7,
    title: "MYSQL",
    percentage: "100%",
  },
  {
    id: 8,
    title: "Git, Github",
    percentage: "85%",
  },
];

const Skills = () => {
  return (
    <div className="py-4">
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">Skills</h3>
          </div>
        </div>
        {skillData.map((skill, id) => (
          <SkillItem skill={skill} key={id} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
